// extracted by mini-css-extract-plugin
export default {"span-cell":"work-order-cell_span-cell__7-jJT"};